export default __webpack_public_path__ + "static/media/3.89a93635.svg";